<template name="LeaveMessage">
  <div class="mySpecParam">
    <div v-for="(item,index) in list" :key="index" style="display:inline-block;">
      <em class="detailUse">{{item.msgTitle}}：</em>
      <el-input v-model="values[index].value" size="small" name="input" :required="item.isRequire" style="width:160px;" :placeholder="'请输入'+item.msgTitle"></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeaveMessage',
  props: {
    msgjson: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      list: [],
      values: []
    }
  },
  watch: {
    values: {
      handler (v) {
        this.$emit('input', JSON.stringify(v))
      },
      deep: true
    }
  },
  created () {
    this.list = JSON.parse(this.msgjson)
    this.list.forEach(ele => {
      ele.error_msg = ''
      ele.error = false
      this.values.push({name: ele.msgTitle, value: ''})
    })
  },
  methods: {
    valid () { // 验证数据有效性
      let isSucess = true
      for (var index = 0; index < this.list.length; index++) {
        if (this.list[index].isRequire && !this.values[index].value) {
          this.$message.error('请输入正确的' + this.list[index].msgTitle)
          isSucess = false
          break
        }
      }
      return isSucess
    }
  }
}
</script>
<style scoped>
  .mySpecParam > div > em {
    float: left;
    font-size: 14px;
    color: #919191;
    text-align: left;
    padding-left: 20px;
    line-height: 32px;
  }
  .mySpecParam > div > div {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeaveMessage.vue